import { BaseService } from "./BaseService";

export interface Team {
    id: string;
    name: string;
    hotelId: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
    _count?: {
        userTeams: number;
        tasks: number;
    };
    userTeams?: {
        staffUser: {
            id: string;
            profileId: string;
            profile?: {
                firstName: string;
                lastName: string;
                photoId?: string;
            };
            position?: string;
        };
    }[];
    responsibleStaffId?: string;
    responsibleStaff?: {
        id: string;
        profileId: string;
        profile?: {
            firstName: string;
            lastName: string;
            photoId?: string;
        };
    };
}

export interface GetTeamsFilters {
    isActive?: boolean;
    userIds?: string[];
    currentPage?: number;
    perPage?: number;
    sortBy: string | null;
    sortOrder: "asc" | "desc" | null;
}

export interface TeamsResponse {
    data: Team[];
    total: number;
    page?: number;
    limit?: number;
}

export interface CreateTeamDto {
    name: string;
    userIds?: string[];
    responsibleStaffId?: string;
}

export interface UpdateTeamDto {
    name?: string;
    userIds?: string[];
    isActive?: boolean;
    responsibleStaffId?: string;
}

class TeamService extends BaseService {
    private basePath = "/teams";

    constructor() {
        super();
    }

    async getTeams(filters?: GetTeamsFilters): Promise<TeamsResponse> {
        return this.get<TeamsResponse>(this.basePath, filters);
    }

    async getTeamById(id: string): Promise<Team> {
        return this.get<Team>(`${this.basePath}/${id}`);
    }

    async createTeam(data: CreateTeamDto): Promise<Team> {
        return this.post<Team>(this.basePath, data);
    }

    async updateTeam(id: string, data: UpdateTeamDto): Promise<Team> {
        return this.patch<Team>(`${this.basePath}/${id}`, data);
    }

    async deleteTeam(id: string): Promise<void> {
        return this.delete<void>(`${this.basePath}/${id}`);
    }
}

export const teamService = new TeamService();
